import { LabeledEnumConst } from '@common/types/type';

export const labeledEnumConstKeyToLabel = <Name extends string, Label extends string>(
  enumConst: LabeledEnumConst<Name, Label>,
  key: Name,
) => {
  return enumConst.ITEMS.find(i => i.KEY === key)!.LABEL;
};
